class Library{

    init(){
        const libraryHelperSubmit = document.getElementById("libraryHelperSubmit");
        if(libraryHelperSubmit != null){
            libraryHelperSubmit.addEventListener('click', this.helperLinkClick);
        }
        const libraryChatNow = document.querySelectorAll('.libraryRegEChatBtn');
        if(libraryChatNow!= null){
            libraryChatNow.forEach(lib =>
                lib.addEventListener('click', this.libraryRegChatNowOnClick)
            );
        }
    }
    helperLinkClick = () => {
        const libraryLink =  document.getElementById("libECorrLink") as HTMLLinkElement;
        const textCopyLink = document.getElementById("libECorrInput") as HTMLInputElement;
        if(libraryLink !== null){
            if(textCopyLink.value){
                let linkVal = libraryLink.href + textCopyLink.value;
                let copylink = document.getElementById("copylink");
                copylink.innerText = linkVal;
            }
        }
    }
    libraryRegChatNowOnClick = () =>{
        window.open('https://libraryh3lp.com/html/chat-box.html?queue=saitlibrary&skin=26541&email=https%3A%2F%2Fwww.sait.ca%2Fstudent-life%2Freg-erhardt-library%2Freg-erhardt-library%2Fconnect%2Fdepartments-and-staff', 'AskUs', 'resizable=1,width=450,height=400'); 
        return false;
    }
}
export default Library;